<div class="modal-header" *ngIf="showAsDialog" ngxModalDraggable>
    <h4 class="modal-title">Dealer{{ isActive ? '' : ' - INACTIVE' }}</h4>
</div>
<div class="flex-fill d-flex flex-column" *ngIf="dealer">
    <div class="btn-toolbar mx-3 mb-0 mt-3 align-items-center" *ngIf="!showAsDialog">
        <button *ngIf="hasChanges() && isActive" class="btn btn-primary me-2" (click)="save()">Save</button>
        <button *ngIf="hasChanges() && isActive" class="btn btn-success" (click)="cancel()">Cancel</button>
        <button *ngIf="!hasChanges() || !isActive" class="btn btn-primary" (click)="close()">Close</button>
        <button (click)="validateDealer()" class="btn btn-primary ms-3" *ngIf="!hasChanges() && !dealer.validated && !readOnly && isActive">Validate Dealer</button>
        <button (click)="unValidateDealer()" class="btn btn-primary ms-3" *ngIf="!hasChanges() && dealer.validated && !readOnly && isActive">UnValidate Dealer</button>
        <button (click)="markReadyToExport()" class="btn btn-success ms-3" *ngIf="!hasChanges() && !dealer.readyToExport">Mark Ready To Export</button>
        <h1 *ngIf="!isActive" class="my-0 ms-3">Dealer Is Inactive</h1>
        <button *ngIf="!hasChanges()" class="btn btn-sm btn-info ms-auto" (click)="auditLog()">Audit Log</button>
    </div>
    <div class="grid-fill m-3">
        <dx-form [formData]="dealer" *ngIf="dealer" [colCount]="1" [readOnly]="!isActive" validationGroup="dealerValidationGroup">
            <dxi-item itemType="tabbed">
                <dxi-tab [title]="'General'" class="" [colCount]="2">
                    <dxi-item itemType="group">
                        <dxi-item itemType="group" caption="Dealer Information">
                            <dxi-item dataField="companyName" [label]="{ text: 'Company' }">
                                <dxi-validation-rule type="required"> </dxi-validation-rule>
                            </dxi-item>
                            <dxi-item dataField="contactName" [label]="{ text: 'Contact' }"></dxi-item>
                            <dxi-item dataField="email" [label]="{ text: 'Sales Email' }"> </dxi-item>
                            <dxi-item dataField="aPEmail" [label]="{ text: 'AP Email' }"> </dxi-item>
                            <dxi-item itemType="group" [colCount]="2">
                                <dxi-item dataField="phone1" [label]="{ text: 'Phone 1' }"></dxi-item>
                                <dxi-item dataField="phone2" [label]="{ text: 'Phone 2' }"></dxi-item>
                            </dxi-item>
                            <dxi-item itemType="group" [colCount]="3">
                                <dxi-item dataField="fax" [label]="{ text: 'Fax' }"></dxi-item>

                                <dxi-item *ngIf="dealer" [label]="{ text: 'Terms' }" [colSpan]="2">
                                    <div *dxTemplate>
                                        <dx-select-box
                                            [(value)]="dealer.dealerTermId"
                                            [items]="terms"
                                            valueExpr="id"
                                            displayExpr="name"
                                            searchEnabled="true"
                                            searchMode="startswith"
                                            (onSelectionChanged)="termsChanged($event)"
                                            [readOnly]="readOnly || showAsDialog"
                                            [readOnly]="!isActive"
                                        >
                                        </dx-select-box>
                                    </div>
                                    <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
                                    <dxi-validation-rule type="range" [min]="'1'" [message]="'Required'"></dxi-validation-rule>
                                </dxi-item>
                            </dxi-item>
                            <dxi-item itemType="group" [colCount]="3">
                                <dxi-item
                                    dataField="salesRepId"
                                    [label]="{ text: 'Sales Rep' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{ items: salesReps, valueExpr: 'id', displayExpr: 'displayName', showClearButton: false }"
                                ></dxi-item>
                                <dxi-item dataField="resaleNumber" [label]="{ text: 'ReSale #' }"></dxi-item>
                                <dxi-item dataField="accountNumber" [label]="{ text: 'Account #' }"></dxi-item>
                            </dxi-item>
                            <dxi-item itemType="group" [colCount]="3">
                                <dxi-item
                                    dataField="colorCode"
                                    [label]="{ text: 'Color' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{ items: colors, showClearButton: false }"
                                ></dxi-item>
                                <dxi-item dataField="salesOrderPricingVisible" [label]="{ text: 'Print Prices' }" editorType="dxCheckBox"></dxi-item>
                                <dxi-item itemType="empty"></dxi-item>
                            </dxi-item>
                            <!-- Freight info here for dialog mode since freight tab isn't visible -->
                            <dxi-item itemType="group" [colCount]="3" *ngIf="showAsDialog">
                                <dxi-item [label]="{ text: 'Loaded Miles' }">
                                    <div *dxTemplate>
                                        <dx-text-box [(value)]="dealer.loadedMiles" (onValueChanged)="mileageChange($event)" [readOnly]="!isActive"></dx-text-box>
                                    </div>
                                </dxi-item>
                                <dxi-item
                                    dataField="calcFreight"
                                    [label]="{ text: 'Calc Freight' }"
                                    editorType="dxNumberBox"
                                    [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                                ></dxi-item>
                                <dxi-item dataField="freight" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##' }"></dxi-item>
                            </dxi-item>

                            <dxi-item itemType="group" [colCount]="2">
                                <dxi-item dataField="northpointCIN" [label]="{ text: 'Northpoint CIN' }"></dxi-item>
                                <dxi-item dataField="northpointCINVerified" editorType="dxDateBox" [label]="{ text: 'Northpoint Verified' }"></dxi-item>
                            </dxi-item>

                            <dxi-item itemType="group" [colCount]="2">
                                <dxi-item dataField="redOakCIN" [label]="{ text: 'Red Oak CIN' }"></dxi-item>
                                <dxi-item dataField="redOakCINVerified" editorType="dxDateBox" [label]="{ text: 'Red Oak Verified' }"></dxi-item>
                            </dxi-item>

                            <dxi-item itemType="group" [colCount]="2">
                                <dxi-item dataField="readyToExport" [label]="{ text: 'Ready to Export' }" [editorOptions]="{ displayFormat: 'shortDateShortTime', disabled: true }">
                                </dxi-item>
                            </dxi-item>

                            <dxi-item itemType="group" [colCount]="2">
                                <dxi-item dataField="quickBooksId" [label]="{ text: 'QB Id' }" [editorOptions]="{ disabled: true }"></dxi-item>
                                <dxi-item dataField="quickBooksLastExport" [label]="{ text: 'Last Export' }" [editorOptions]="{ disabled: true }"></dxi-item>
                                <!-- <dxi-item dataField="quickBooksOnlineId" [label]="{ text: 'New QB Id' }" [editorOptions]="{ disabled: true }"></dxi-item>
                                <dxi-item dataField="quickBooksOnlineLastExport" [label]="{ text: 'New QB Last Export' }" [editorOptions]="{ disabled: true }"></dxi-item> -->
                            </dxi-item>

                            <dxi-item itemType="group" [colCount]="4">
                                <dxi-item dataField="isValidated" [label]="{ text: 'Validated' }" [editorOptions]="{ disabled: true }" editorType="dxCheckBox"></dxi-item>
                                <dxi-item dataField="validated" [label]="{ text: 'Validated' }" [editorOptions]="{ disabled: true }"></dxi-item>
                                <dxi-item dataField="channelPartner" [label]="{ text: 'Channel Partner' }" editorType="dxCheckBox"></dxi-item>
                                <dxi-item dataField="noPrePay" [label]="{ text: 'No PrePay' }" editorType="dxCheckBox"></dxi-item>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" caption="Notes">
                            <dxi-item
                                dataField="shippingNote"
                                [label]="{ text: 'Shipping Notes' }"
                                editorType="dxTextArea"
                                [editorOptions]="{
                                    height: '150px',
                                    disabled: !dealer.shipSameAsBilling,
                                    readOnly: !isActive,
                                    placeholder: !dealer.shipSameAsBilling ? 'Shipping Notes On Individual Shipping Addresses' : '',
                                }"
                            ></dxi-item>
                            <dxi-item dataField="notes" [label]="{ text: 'Internal Notes' }" editorType="dxTextArea" [editorOptions]="{ height: '150px' }"></dxi-item>
                        </dxi-item>
                    </dxi-item>

                    <dxi-item itemType="group">
                        <dxi-item itemType="group" caption="Billing Address">
                            <dxi-item dataField="billAddress1" [label]="{ text: 'Address 1' }"></dxi-item>
                            <dxi-item dataField="billAddress2" [label]="{ text: 'Address 2' }"></dxi-item>
                            <dxi-item itemType="group" [colCount]="3">
                                <dxi-item dataField="billCity" [label]="{ text: 'City' }" [colSpan]="2"></dxi-item>
                                <dxi-item dataField="billState" [label]="{ text: `${dealer.billCountry === 'CANADA' ? 'Province' : 'State/Province'}` }" [visible]="dealer.billCountry !== 'US'"></dxi-item>
                                <dxi-item
                                    dataField="billState"
                                    [label]="{ text: 'State' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{ items: states, showClearButton: false }"
                                    [visible]="dealer.billCountry === 'US'"
                                ></dxi-item>
                                <dxi-item dataField="billZip" [label]="{ text: 'Zip' }"></dxi-item>
                                <dxi-item
                                    dataField="billCountry"
                                    [label]="{ text: 'Country' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{ items: countries, showClearButton: false }"
                                ></dxi-item>
                                <dxi-item dataField="countryOther" [label]="{ text: 'Country Other' }" [visible]="dealer.billCountry === 'OTHER'"></dxi-item>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" caption="Ship To">
                            <dxi-item dataField="shipSameAsBilling" [label]="{ text: 'Same as billing' }" editorType="dxCheckBox"></dxi-item>
                            <dxi-item *ngIf="!dealer.shipSameAsBilling">
                                <div class="grid-fill">
                                    <dx-data-grid
                                        #shippingAddressGrid
                                        height="400"
                                        [dataSource]="dealer.shipAddresses"
                                        [showRowLines]="true"
                                        keyExpr="id"
                                        (onToolbarPreparing)="onToolbarPreparing($event)"
                                        (onSelectionChanged)="selectionChange($event)"
                                        (onCellDblClick)="rowDoubleClick($event)"
                                    >
                                        <dxi-column cellTemplate="columnTemplate">
                                            <div *dxTemplate="let item of 'columnTemplate'">
                                                <div style="font-weight: bold">{{ item.data.location }}</div>
                                                <div>{{ item.data.address1 }}</div>
                                                <div [hidden]="!item.data.address2">{{ item.data.address2 }}</div>
                                                <div>{{ item.data.city }}, {{ item.data.state }} {{ item.data.zip }} {{ item.data.country }}</div>
                                                <div [hidden]="!item.data.contactName">{{ item.data.contactName }}</div>
                                                <div>{{ 'Loaded Miles: ' + item.data.loadedMiles }} ---- {{ 'Calc Freight: $' + item.data.loadedMiles * mileageRate }}</div>
                                                <div>{{ 'Notes: ' + (item.data.notes ? item.data.notes : '') }}</div>
                                            </div>
                                        </dxi-column>
                                        <div *dxTemplate="let data of 'toolbarButtons'">
                                            <button type="button" (click)="editShippingAddress()" class="btn btn-sm btn-success me-1" *ngIf="!readOnly && isActive">Add</button>
                                            <button
                                                type="button"
                                                (click)="editShippingAddress(shippingAddressGrid.instance.getSelectedRowsData()[0])"
                                                class="btn btn-sm btn-primary me-1"
                                                [disabled]="!canEditAndDeleteShipAddress"
                                                *ngIf="!readOnly && isActive"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                type="button"
                                                (click)="deleteShippingAddress(shippingAddressGrid.instance.getSelectedRowsData()[0])"
                                                class="btn btn-sm btn-danger me-2"
                                                [disabled]="!canEditAndDeleteShipAddress"
                                                *ngIf="!readOnly && isActive"
                                            >
                                                Delete
                                            </button>
                                        </div>
                                        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="dealer-detail-grid"></dxo-state-storing>
                                    </dx-data-grid>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" caption="Attachments" *ngIf="key !== 'new'">
                            <dxi-item>
                                <ul style="list-style-type: none; padding-inline-start: 0px" *ngIf="attachments">
                                    <li *ngFor="let attachment of attachments">
                                        <a title="remove" (click)="removeAttachment($event, attachment)"> <i class="fa fa-times" aria-hidden="true"></i> </a>&nbsp;
                                        <a title="view" (click)="openAttachment(attachment)">{{ attachment.name }}</a>
                                    </li>
                                </ul>
                            </dxi-item>
                            <dxi-item>
                                <div *dxTemplate>
                                    <dx-file-uploader
                                        name="fileUpload"
                                        selectButtonText="Select File(s)"
                                        class="attachments"
                                        accept="*"
                                        uploadMode="instantly"
                                        [showFileList]="false"
                                        [multiple]="true"
                                        [uploadUrl]="uploadUrl"
                                        [uploadHeaders]="uploadHeader"
                                        (onUploadStarted)="uploadStarted($event)"
                                        (onUploadError)="uploadError($event)"
                                        (onUploaded)="uploaded($event)"
                                    >
                                    </dx-file-uploader>
                                </div>
                            </dxi-item>
                        </dxi-item>

                        <dxi-item itemType="group" caption="Sales Information">
                            <dxi-item itemType="group" [colCount]="3">
                                <dxi-item dataField="calcPricingTier.name" [label]="{ text: 'Calculated Tier' }" [editorOptions]="{ disabled: true }"></dxi-item>
                                <dxi-item
                                    dataField="pricingTierId"
                                    [label]="{ text: 'Tier Override' }"
                                    editorType="dxSelectBox"
                                    [editorOptions]="{ items: pricingTiers, valueExpr: 'id', displayExpr: 'name', showClearButton: false, disabled: !canUpdateTier }"
                                ></dxi-item>
                                <dxi-item *ngIf="dealer" [label]="{ text: 'Tier Qualifying Sales' }">
                                    <div *dxTemplate>
                                        <dx-number-box [(value)]="qualifyingSales" [format]="'$#,##0.00##'" [disabled]="true"> </dx-number-box>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                            <dxi-item itemType="group" [colCount]="3">
                                <dxi-item *ngIf="dealer" [label]="{ text: 'YTD Sales' }">
                                    <div *dxTemplate>
                                        <dx-number-box [(value)]="sales" [format]="'$#,##0.00##'" [disabled]="true"> </dx-number-box>
                                    </div>
                                </dxi-item>
                                <dxi-item *ngIf="dealer" [label]="{ text: 'YTD Payments' }">
                                    <div *dxTemplate>
                                        <dx-number-box [(value)]="payments" [format]="'$#,##0.00##'" [disabled]="true"> </dx-number-box>
                                    </div>
                                </dxi-item>
                                <dxi-item *ngIf="dealer" [label]="{ text: 'YTD Invoices' }">
                                    <div *dxTemplate>
                                        <dx-number-box [(value)]="invoices" [format]="'$#,##0.00##'" [disabled]="true"> </dx-number-box>
                                    </div>
                                </dxi-item>
                            </dxi-item>
                        </dxi-item>
                        <!-- <dxi-item itemType="group" caption="ACH Information" *ngIf="achInfo">
                            <div *dxTemplate>
                                <dx-form [formData]="achInfo" [colCount]="3" [disabled]="true">
                                    <dxi-item dataField="accountType"></dxi-item>
                                    <dxi-item dataField="accountName"></dxi-item>
                                    <dxi-item dataField="bankName"></dxi-item>
                                    <dxi-item dataField="accountNumber"></dxi-item>
                                    <dxi-item dataField="routingNumber"></dxi-item>
                                </dx-form>
                            </div>
                        </dxi-item> -->
                    </dxi-item>
                </dxi-tab>
                <dxi-tab *ngIf="!showAsDialog" [title]="'Freight'">
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item [label]="{ text: 'Loaded Miles' }">
                            <div *dxTemplate>
                                <dx-text-box [(value)]="dealer.loadedMiles" (onValueChanged)="mileageChange($event)" [readOnly]="!isActive"></dx-text-box>
                            </div>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item [label]="{ text: 'Mileage Rate' }">
                            <div *dxTemplate>
                                <dx-number-box [value]="mileageRate" [disabled]="true" [format]="'$#,##0.00##'"> </dx-number-box>
                            </div>
                        </dxi-item>
                        <dxi-item
                            dataField="calcFreight"
                            [label]="{ text: 'Calc Standard Freight' }"
                            editorType="dxNumberBox"
                            [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                        >
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item [label]="{ text: 'Discount Mileage Rate' }">
                            <div *dxTemplate>
                                <dx-number-box [value]="discountMileageRate" [disabled]="true" [format]="'$#,##0.00##'"> </dx-number-box>
                            </div>
                        </dxi-item>
                        <dxi-item
                            dataField="calcDiscountFreight"
                            [label]="{ text: 'Calc Discount Freight' }"
                            editorType="dxNumberBox"
                            [editorOptions]="{ format: '$#,##0.00##', disabled: true }"
                        >
                        </dxi-item
                    ></dxi-item>
                    <dxi-item itemType="group" [colCount]="4">
                        <dxi-item dataField="freight" [label]="{ text: 'Freight' }" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##' }"> </dxi-item>
                    </dxi-item>
                </dxi-tab>
                <dxi-tab *ngIf="canSeeSales && !showAsDialog" [title]="'Sales Summary'" class="p-0">
                    <dxi-item>
                        <div *dxTemplate>
                            <div *ngIf="!showAsDialog && canSeeSales" class="d-flex">
                                <div *ngIf="!!salesSummary && salesSummary.length > 0" class="col-sm-4">
                                    <table class="table mt-3">
                                        <thead>
                                            <tr>
                                                <th>Year</th>
                                                <th>Month</th>
                                                <th>Amount</th>
                                                <th>Order Count</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let summary of salesSummaryWithoutZeros">
                                                <td class="col-xs-5">{{ summary.year }}</td>
                                                <td class="col-xs-5">{{ summary.month }}</td>
                                                <td class="col-xs-1">{{ summary.orderTotal | currency }}</td>
                                                <td class="col-xs-1">{{ summary.orderCount }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div class="col-sm-8">
                                    <dx-chart
                                        id="salesChart"
                                        [dataSource]="salesSummary"
                                        title="Sales Orders"
                                        (onPointClick)="onPointClick($event)"
                                        (onLegendClick)="legendClickHandler($event)"
                                    >
                                        <dxo-common-series-settings argumentField="month" valueField="orderTotal" type="bar">
                                            <dxo-label [visible]="false" [format]="{ type: 'currency', precision: 2 }"> </dxo-label>
                                        </dxo-common-series-settings>
                                        <dxo-series-template nameField="year"></dxo-series-template>
                                        <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeToolTip" [format]="{ type: 'currency', precision: 2 }"></dxo-tooltip>
                                        <dxo-export [enabled]="true"></dxo-export>
                                        <dxo-argument-axis [visualRange]="visualRange"> </dxo-argument-axis>
                                    </dx-chart>
                                </div>
                            </div>
                        </div>
                    </dxi-item>
                </dxi-tab>

                <dxi-tab *ngIf="!showAsDialog" title="Contacts">
                    <dxi-item>
                        <app-contact-grid *dxTemplate class="grid-fill" [entityId]="dealer.id" [entityType]="'Dealer'" [readOnly]="readOnly || !isActive"></app-contact-grid>
                    </dxi-item>
                </dxi-tab>

                <dxi-tab *ngIf="!showAsDialog" title="Notes">
                    <dxi-item>
                        <app-dealer-notes
                            *dxTemplate
                            class="grid-fill"
                            [entityId]="dealer.id"
                            [entityType]="'Dealer'"
                            [readOnly]="readOnly || !isActive"
                            [dealerId]="dealer.id"
                        ></app-dealer-notes>
                    </dxi-item>
                </dxi-tab>
            </dxi-item>
        </dx-form>
    </div>
</div>
<div class="modal-footer" *ngIf="showAsDialog">
    <button *ngIf="isActive" (click)="saveDialog()" class="btn btn-success">Save</button>
    <button (click)="cancelDialog()" class="btn btn-light ms-1">Cancel</button>
</div>
